import { defineStore } from 'pinia';

export const useBannerStore = defineStore('bannerStore', {
  state: () => ({
    title: undefined as string | undefined,
    text: undefined as string | undefined,
    icon: undefined as string | undefined,
    bgColor: undefined as string | undefined,
    linkButtonUrl: undefined as string | undefined,
    linkButtonText: undefined as string | undefined,
  }),
  actions: {
    clear() {
      this.title = undefined;
      this.text = undefined;
      this.icon = undefined;
      this.bgColor = undefined;
      this.linkButtonUrl = undefined;
      this.linkButtonText = undefined;
    },
    set(
      title?: string,
      text?: string,
      icon?: string,
      bgColor?: string,
      linkButtonUrl?: string,
      linkButtonText?: string,
    ) {
      this.title = title;
      this.text = text;
      this.icon = icon;
      this.bgColor = bgColor;
      this.linkButtonUrl = linkButtonUrl;
      this.linkButtonText = linkButtonText;
    },
  },
  getters: {
    hasData(state) {
      return state.title && state.text;
    },
  },
});
